/*
 * Heath Kane theme behaviour: search overlay and the collection Filter panel.
 * Rewritten readable from the original minified main.js. Behaviour is the same,
 * plus: an "In stock" filter, and prices over £999 (with a comma) now filter
 * correctly.
 */
$(document).ready(function () {
  // Search overlay
  $('.search-icon a, .close-search a, .open-search-bar').on('click', function (e) {
    e.preventDefault();
    $('.search-icon').toggleClass('open');
    $('#search-bar').toggleClass('open');
    $('#search-bar input').focus();
  });

  // Build the colour filter from the colours present on the page
  var colours = [];
  $('.product-preview').each(function () {
    colours = colours.concat(($(this).attr('data-colour') || '').split(','));
  });
  var availableColours = Array.from(new Set(colours)).filter(Boolean);
  availableColours.forEach(function (colour) {
    $('.tag-filters-colour').append(
      '<li class="tag-filters__item tag-colour tag-colour-' + colour + '" data-type="colour">' +
        '<span class="checkmark" style="background: ' + colour + ';"></span><a href="#">' + colour + '</a>' +
      '</li>'
    );
  });

  $('.filter-bar').on('click', function () {
    $(this).toggleClass('open');
    $(this).siblings('.tag-filters').slideToggle();
  });

  $('.filter-selector').on('click', function () {
    $(this).toggleClass('open');
    $('.filter-content').toggleClass('open');
  });

  function priceOf(element) {
    // data-price is formatted money, e.g. "£1,100.00"
    var digits = String($(element).attr('data-price') || '').replace(/[^0-9.]/g, '');
    return Number(digits) || 0;
  }

  $(document).on('click', '.tag-filters__item a', function (e) {
    var listItem = e.target.closest('li');
    var filterType = $(listItem).attr('data-type');

    // Size tags render as real tag links (good for search engines) but filter in place.
    e.preventDefault();
    $('.remove-item').removeClass('remove-item');
    $('.prepended-content').remove();

    var parentElement = $(this).closest('.filter');

    if ($(listItem).hasClass('clear') || $(listItem).hasClass('sale')) {
      $('.tag-filters__item').removeClass('active');
      $('.filter-bar, .tag-filters, .filter-content, .filter-selector').removeClass('open');
      $('.tag-filters').slideUp();
    } else {
      if (filterType === 'price') {
        var wasActive = $(listItem).hasClass('active');
        $(parentElement).find('.tag-filters__item').removeClass('active');
        if (wasActive) $(listItem).addClass('active');
      }
      $(listItem).toggleClass('active');
      $(parentElement).find('.filter-bar').removeClass('open');
      $(parentElement).find('.tag-filters').removeClass('open');
    }

    var selectedSize = [];
    $('[data-type=size].active').each(function () { selectedSize.push($(this).find('a').text()); });
    var selectedColour = [];
    $('[data-type=colour].active').each(function () { selectedColour.push($(this).find('a').text()); });

    var activeSize = selectedSize.join(',');
    var activePrice = $('[data-type=price].active').text();
    var activeColours = selectedColour.join(',');
    var activeSale = $(listItem).hasClass('sale');
    var activeStock = $('[data-type=stock].active').length > 0;

    $('.filter-bar-price').text('Price: ' + activePrice);
    $('.filter-bar-size').text('Size: ' + activeSize.split(',').join(', '));
    $('.filter-bar-colour').text('Colour: ' + activeColours.split(',').join(', '));

    var maxValue = 1e6;
    var minValue = 0;
    var $activePrice = $('[data-type=price].active');
    if ($activePrice.attr('data-value-min') || $activePrice.attr('data-value-max')) {
      maxValue = Number($activePrice.attr('data-value-max')) || 1e6;
      minValue = Number($activePrice.attr('data-value-min')) || 0;
    }

    $('.product-preview').each(function () {
      $(this).addClass('remove-item');

      var sizePasses = true;
      if (activeSize) {
        var elementSizes = ($(this).attr('data-size') || '').split(',');
        sizePasses = activeSize.split(',').some(function (size) { return elementSizes.indexOf(size) !== -1; });
      }

      var pricePasses = true;
      if (activePrice) {
        var price = priceOf(this);
        pricePasses = price <= maxValue && price >= minValue;
      }

      var colourPasses = true;
      if (activeColours) {
        var elementColours = ($(this).attr('data-colour') || '').toLowerCase().split(',');
        colourPasses = activeColours.toLowerCase().split(',').some(function (c) { return elementColours.indexOf(c) !== -1; });
      }

      var salePasses = activeSale ? Boolean($(this).attr('data-sale')) : true;
      var stockPasses = activeStock ? $(this).attr('data-available') === 'true' : true;

      if (pricePasses && sizePasses && colourPasses && salePasses && stockPasses) {
        $(this).removeClass('remove-item');
      }
    });

    if ($('.product-preview:not(.remove-item)').length === 0) {
      $('#ajax-content .row').first().prepend('<div class="large-12 columns prepended-content"><p>There are no products in this view.</p></div>');
    }
  });
});
